export default __webpack_public_path__ + "static/media/pelayanan.99ffc561.png";